export * from './keys.pipe';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/keys/index.ts